import { useMutation } from "react-query";

import { postCreateUserInsurance, postUpdateUserInsurance } from "api/insurance";
import { useGlobalToast } from "components/GlobalToastProvider";

/**
 * `insuranceSubmission` determines whether to update or create a client's insurance record and
 * then calls the appropriate mutation function with the provided insurance data.
 */
const insuranceSubmission = (values) => {
  const mutationFn = !values.id ? postCreateUserInsurance : postUpdateUserInsurance;
  return mutationFn({ insuranceUserId: values.id, ...values });
};

const useUpdateClientInsurance = (options = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isIdle, isLoading, ...rest } = useMutation(
    (payload) => insuranceSubmission(payload),
    {
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while updating insurance",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    updateInsuranceMutation: mutate,
    isMutationInsuranceIdle: isIdle,
    isMutationInsuranceLoading: isLoading,
    ...rest,
  };
};

export default useUpdateClientInsurance;
